import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpUtilService } from '../http-util.service';

@Injectable({
  providedIn: 'root',
})
export class LoanStatusService {
  constructor(private http: HttpUtilService) {}

  getLoanStatus(referenceId: string, isSearchByRefNo: boolean): Observable<any> {

    const encodedRef = encodeURIComponent(referenceId);
    const url = `/LoanStatusService.asmx/GetLoanStatus?isSearchByRefNo=${isSearchByRefNo}&referenceId=${encodedRef}`;
  
    return this.http.get(url);
  }

  changeLoanAmount(payload: { LoanAmount: string; BuyersOrderNumber: string; LoanPeriod: string; LoanRate: string }): Observable<any> {
    const url = `/LoanStatusService.asmx/ChangeLoanAmount`;
    return this.http.post(url, payload);
  }

  changeLoanPeriod(payload: { LoanAmount: string; LoanPeriod: string; LoanRate: string }): Observable<any> {
    const url = `/LoanStatusService.asmx/ChangeLoanPeriod`;
    return this.http.post(url, payload);
  }

  changeLoanRate(payload: { LoanAmount: string; LoanPeriod: string; LoanRate: string }): Observable<any> {
    const url = `/LoanStatusService.asmx/ChangeLoanRate`;
    return this.http.post(url, payload);
  }
  
  updateLoanStatus(payload: any): Observable<any> {
    const url = `/LoanStatusService.asmx/Update`;
    return this.http.post(url, payload);
  }
  
}
